import http from '@root/utils/axios/admin';

let state = {
    SourceWebhookList: [],
    SourceWebhookLogsList: [],
}

let actions = {

    fetchSourceWebhookList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/source/webhook', { params: filter }).then((response) => {
                commit('setSourceWebhookList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchSourceWebhookLogsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/source/webhook/logs', { params: filter }).then((response) => {
                commit('setSourceWebhookLogsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



}


let mutations = {
    setSourceWebhookList(state, data) {
        state.SourceWebhookList = data;
    },
    setSourceWebhookLogsList(state, data) {
        state.SourceWebhookLogsList = data;
    }
}

export default {
    state,
    actions,
    mutations
}